import { render, staticRenderFns } from "./BoxTagging.vue?vue&type=template&id=167ab3a2&scoped=true"
import script from "./BoxTagging.vue?vue&type=script&lang=js"
export * from "./BoxTagging.vue?vue&type=script&lang=js"
import style0 from "./BoxTagging.vue?vue&type=style&index=0&id=167ab3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ab3a2",
  null
  
)

export default component.exports